import { Card, Button, ListGroup, Container, Row, Col, Nav, CardBody } from "react-bootstrap";
import { Divider, Flex, Tag } from 'antd';

import { HiOutlineMail } from "react-icons/hi";
import { TbPhone } from "react-icons/tb";
import { PiMapPin } from "react-icons/pi";
import { RiCalendarTodoLine } from "react-icons/ri";
import { FaRegCircle } from "react-icons/fa";

export default function CustomerInformationComponent({data}){

  /*
  const secciones=[
    {id:1,seccion:'Nación'},
    {id:2,seccion:'Mundo'},
    {id:3,seccion:'Metrópoli'},
    {id:4,seccion:'Estados'},
    {id:5,seccion:'Opinión'},
    {id:6,seccion:'Cartera'},
    {id:7,seccion:'Universal Deportes'},
    {id:8,seccion:'Espectáculos'},
    {id:9,seccion:'Cultura'},
    {id:10,seccion:'Ciencia y Salud'},
  ]
  */

  const suplementos=[
    {id:1,suplemento:'Autopistas'},
    {id:2,suplemento:'Clase'},
    {id:3,suplemento:'De Última'},
    {id:4,suplemento:'Destinos'},    
    {id:6,suplemento:'Techbit'},    
  ]

  return (
    <Col xl={3} className="cdp-component">
      <Card>
        <CardBody>
          <h6 className="mb-3 fw-semibold">Información</h6>
          <div className="mb-3" style={{
            overflow:'hidden',
            overflowWrap:'anywhere'
          }}>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2" >
                <HiOutlineMail />
              </span>
              <p className="basic-information" 
              style={{wordWrap:'break-word'}}
              >
                {data.email}
              </p>
            </div>
            <div className="d-flex align-items-center mb-3 d-none">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2">
                <TbPhone />
              </span>
              <p className="basic-information">-</p>
            </div>
            <div className="d-flex align-items-center mb-3 d-none">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2">
                <PiMapPin />
              </span>
              <p className="basic-information">-</p>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2">
                <RiCalendarTodoLine />
              </span>
              <p className="basic-information">Ultima visita: {data.lastvisit}</p>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2">
                <FaRegCircle />
              </span>
              <p className="basic-information">Piano ID: {data.uidp}</p>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2">
                <FaRegCircle />
              </span>
              <p className="basic-information">PPDI: {data.uid}</p>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2">
                <FaRegCircle />
              </span>
              <p className="basic-information">Id Analytics: {data.analyticsid}</p>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2">
                <FaRegCircle />
              </span>
              <p className="basic-information">Sitio: {data.site}</p>
            </div>
            <div className="d-flex align-items-center mb-3">
              <span className="avatar avatar-xs bg-light-300 p-0 rounded-circle text-dark me-2">
                <FaRegCircle />
              </span>
              <p className="basic-information">Paginas vistas: {data.pageviews}</p>
            </div>
          </div>
          <h6 className="mb-3 fw-semibold">Preferencias</h6>
          {
            data.section&&<>
              <div>Secciones:</div>
              <div className="categorias-list">
                <Flex gap="4px 0" wrap>
                  {
                    data.section&&Object.keys(data.section).map((key) => (
                      <Tag key={key} color="blue">{key} ({data.section[key]})</Tag>
                    ))
                  }
                </Flex>
              </div>
            </>
          }
          {/*
          <div className="mt-2">Suplementos:</div>
          <div className="categorias-list">
          <Flex gap="4px 0" wrap>
              {
                suplementos.map((item,index) => (
                  <Tag key={index} color="geekblue">{item.suplemento}</Tag>
                ))
              }
            </Flex>
          </div>
          */}
        </CardBody>
      </Card>
    </Col>
  )
}